import { render, staticRenderFns } from "./MagazzinoArticoliGiacenzeListComponent.vue?vue&type=template&id=48d6fa52&scoped=true"
import script from "./MagazzinoArticoliGiacenzeListComponent.vue?vue&type=script&lang=js"
export * from "./MagazzinoArticoliGiacenzeListComponent.vue?vue&type=script&lang=js"
import style0 from "./MagazzinoArticoliGiacenzeListComponent.vue?vue&type=style&index=0&id=48d6fa52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d6fa52",
  null
  
)

export default component.exports